import { WeatherApiResponse, HourlyApiResponse } from '../types/weather';

const API_KEY = process.env.REACT_APP_OWM_API_KEY; 
const BASE_URL = 'https://api.openweathermap.org/data/2.5';

export async function fetchCurrentWeather(city: string): Promise<WeatherApiResponse> {
  const res = await fetch(`${BASE_URL}/weather?q=${encodeURIComponent(city)}&appid=${API_KEY}&units=metric&lang=en`);
  if (!res.ok) throw new Error('City not found');
  return res.json();
}

export async function fetchHourlyWeather(lat: number, lon: number) {
  const res = await fetch(
    `${BASE_URL}/forecast?lat=${lat}&lon=${lon}&appid=${API_KEY}&units=metric&lang=en`
  );
  if (!res.ok) throw new Error('Hourly forecast not found');
  const data = await res.json();
  return {
    hourly: data.list.map((item: any) => ({
      dt: item.dt,
      temp: item.main.temp,
    })),
  };
}

